module.exports = {"title":"Central Settings","datatable":{"code":"Code","name":"Name"}};